<template>
  <div>
  <nav id="navbar-main" class="navbar navbar-main navbar-expand-lg navbar-dark navbar-theme-primary headroom" style="padding-bottom: 0.8rem !important;padding-top: 0.8rem!important;position:fixed;height: 71px;">
      <div style="width: 100%; display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; padding-left: 1rem; padding-right: 1rem;">
          <router-link to="/dashboard/" style="background: none!important;" class="navbar-brand">
              <div class="d-flex align-items-center">
                  <img src="https://documentify.com/logo/logo-dark-bg.png" class="mcqueen_desktop" style="max-width:195px;height: auto;" alt="Documentify Logo">
                  <img src="https://documentify.com/logo/icon-white.png" class="mcqueen_mobile" style="display:none;max-width:40px;height: auto;" alt="Documentify Logo">
              </div>
          </router-link>
          <div class="d-lg-block fiumfiummcqueen mcqueen_desktop">
              <!-- UPGRADE -->
              <a v-show="propsdata[0].paid !== 'yes' && propsdata[0].email !== '' && propsdata[0].cargado" :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_header_button'" class="btn btn-md btn-pricing-plan animate-up-2" style="color: #000000;background-color: #ffffff;border-color: #ffffff;display:none;">
                <svg class="sc-eNQAEJ bqIowC" width="24" height="24" fill="#f4bd00" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg>
                Upgrade Now</a>
                <!-- UPGRADED -->
                <a v-show="propsdata[0].paid === 'yes' && propsdata[0].cancel_at_period_end !== 'yes' && propsdata[0].cargado" class="btn btn-md btn-pricing-plan" style="color: #f4bd00;background-color: #ffffff;border-color: #f4bd00;cursor:initial;display:none;">
                  <svg class="sc-eNQAEJ bqIowC" width="24" height="24" fill="#f4bd00" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg>
                  Premium</a>
                  <div v-if="propsdata[0].email !== ''" class="dropdown mb-lg-0" style="display: inline-block;padding: 0 0 0 20px;">
                    <a id="langsDropdown" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle footer-language-link pb-2" style="color: #fff;">
                      {{propsdata[0].email}} <i class="fas fa-chevron-down ml-1"></i>
                    </a>
                    <div aria-labelledby="langsDropdown" class="dropdown-menu dropdown-menu-center mt-0" style="left: unset!important;right:0;">
                        <a href="/" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-home mr-2"></i> Home</a>
                        <router-link to="/dashboard/" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-file mr-2"></i> Dashboard</router-link>
                        <router-link to="/dashboard/account" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-cog mr-2"></i> Account Settings</router-link>
                        <router-link to="/dashboard/billing" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-file-alt mr-2"></i> Billing</router-link>
                        <a href="/contact" target="_blank" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-inbox mr-2"></i> Contact</a>
                        <a href="https://documentify.helpscoutdocs.com/" target="_blank" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-question-circle mr-2"></i> Help Center</a>
                        <a href="/logout" class="dropdown-item text-sm"><i class="fas fa-sign-out-alt mr-2"></i> Log Out</a>
                    </div>
                  </div>
                  <div v-if="propsdata[0].email === ''" class="dropdown mb-lg-0" style="display: inline-block;padding: 0 0 0 20px;">
                    <a id="langsDropdown" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle footer-language-link pb-2" style="color: #fff;">
                      Guest <i class="fas fa-chevron-down ml-1"></i>
                    </a>
                    <div aria-labelledby="langsDropdown" class="dropdown-menu dropdown-menu-center mt-0" style="left: unset!important;right:0;">
                        <router-link to="/dashboard/create-account" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-sign-in-alt mr-2"></i> Create Account</router-link>
                    </div>
                  </div>
          </div>
          <div class="mcqueen_mobile" style="display:none;">
              <div v-if="propsdata[0].email !== ''" class="dropdown mb-lg-0" style="display: block;text-align:right;">
                <a id="langsDropdown" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle footer-language-link pb-2" style="color: #fff;">
                  My Account <i class="fas fa-chevron-down ml-1"></i>
                </a>
                <div aria-labelledby="langsDropdown" class="dropdown-menu dropdown-menu-center mt-0" style="left: unset!important;right:0;">
                    <a href="/" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-home mr-2"></i> Home</a>
                    <router-link to="/dashboard/" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-file mr-2"></i> Dashboard</router-link>
                    <router-link to="/dashboard/account" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-cog mr-2"></i> Account Settings</router-link>
                    <router-link to="/dashboard/billing" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-file-alt mr-2"></i> Billing</router-link>
                    <a href="/contact" target="_blank" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-inbox mr-2"></i> Contact</a>
                    <a href="https://documentify.helpscoutdocs.com/" target="_blank" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-question-circle mr-2"></i> Help Center</a>
                    <a href="/logout" class="dropdown-item text-sm"><i class="fas fa-sign-out-alt mr-2"></i> Log Out</a>
                </div>
              </div>
              <div v-if="propsdata[0].email === ''" class="dropdown mb-lg-0" style="display: block;padding: 15px 0 0 20px;text-align:right;">
                <a id="langsDropdown" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle footer-language-link pb-2" style="color: #fff;">
                  Guest <i class="fas fa-chevron-down ml-1"></i>
                </a>
                <div aria-labelledby="langsDropdown" class="dropdown-menu dropdown-menu-center mt-0" style="left: unset!important;right:0;">
                  <router-link to="/dashboard/create-account" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-sign-in-alt mr-2"></i> Create Account</router-link>
                </div>
              </div>
          </div>
      </div>
  </nav>
</div>
</template>

<style>
@media (max-width:991px){
  .megamenu-item{
    max-width:none!important;
    width: 100%!important;
  }
  .featuresdiv{
    max-width: 100%!important;
  }
  .sinmargin{
    margin: 0 auto!important;
    width: 100%!important;
  }
  .elmaildash{
    float:unset!important;
    margin-top:10px;
  }
}
@media (max-width:399px) {
  .fiumfiummcqueen{
    padding-top: 15px;
  }
}
@media (min-width:992px){
  .p-none{
    display:none!important;
  }
}
.navbar-brand img{
  max-width: 120px;
  width: 100%;
}
.navbar{
  background-color: #6ca7ff;
}
.navimg{
  width: 30px;
}
.megamenu-item{
  display:inline-block!important;
  max-width: 250px;
}
.megamenu-item2{
  display:inline-block!important;
  max-width: 1000px;
  margin-bottom:-30px;
}
.list2{
  font-size: 18px;
}
.list3{
  font-size: 14px!important;
  color: #000;
  font-weight:500
}
.featuresdiv{
  width: 758px!important;
}
.list-style-none{
  display:flex;
}
.mb90{
  margin-bottom:-10px!important;
}
.wwa{
  background-color: #ffffff;
  border: 2px solid #0948B3;
  color:#0948B3 !important;
}
.divnav{
  margin: 0 auto!important;
}
@media (min-width:991px) {
.mindesktopwidth{
  width: 500px!important;
}
.webkitinlinedesktop{
  display: -webkit-inline-box;
}
.paddingendesktop1{
  padding: 0 0 0 10px;
}
.paddingendesktop2{
  padding: 0 10px 0 0;
}
}
.login-button {
  color: #ffffff;
  font-weight: 600;
  background-color: transparent;
  padding: 15px;
}
.login-button-hov:hover {
  background-color: transparent!important;
  color: #c7c7c7!important;
}

/* DASHBOARD */
.jwoEpG {
    display: block;
    width: 100%;
    background-color: rgb(242, 245, 250);
    padding: 110px 20px 0px 20px;
}
.jPMoWD {
    max-width: 1120px;
    margin: 0px auto;
}
.cbHCIC {
    font-size: 32px;
    line-height: 34px;
    margin-bottom: 2px;
}
.iQGrHz {
    position: relative;
    display: flex;
    -webkit-box-align: baseline;
    align-items: baseline;
    -webkit-box-pack: justify;
    justify-content: space-between;
    border-bottom: 1px solid rgb(221, 227, 240);
}
.VvJwP {
    width:80%;
    position: relative;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    height: 100%;
}
.ceBpjv {
    color: rgb(38, 43, 51);
    margin-right: 24px;
    cursor: pointer;
    transition: color 0.1s ease 0s;
    padding: 10px 0px;
    text-align: center;
}
.goxPqP {
    color: #292e35;
    margin-right: 24px;
    cursor: pointer;
    transition: color 0.1s ease 0s;
    padding: 10px 0px;
    text-align: center;
}
.faWvy {
    display: block;
    position: absolute;
    left: 0px;
    bottom: -1px;
    width: 100px;
    height: 2px;
    background-color: rgb(33, 150, 243);
    transform-origin: 0px 0px;
    transform: translateX(0px) scaleX(0.67);
    transition: transform 0.3s ease 0s;
}
.dqUEtJ {
    -webkit-appearance: none;
    text-align: center;
    color: rgb(255, 255, 255);
    background-color: #6ca7ff;
    cursor: pointer;
    user-select: none;
    pointer-events: auto;
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    position: initial;
    bottom: 15px;
    right: 0px;
    outline: none;
    border-radius: 4px;
    transition: background-color 0.1s ease 0s, box-shadow 0.1s ease 0s;
    border-width: 0px;
    padding: 8px 12px 8px 4px;
}
.cTABXS {
    font-weight: 600;
    -webkit-appearance: none;
    text-align: center;
    color: rgb(255, 255, 255);
    background-color: #6ca7ff;
    cursor: pointer;
    user-select: none;
    pointer-events: auto;
    font-size: 16px;
    line-height: 20px;
    width: 100%;
    margin-bottom: 32px;
    display: none;
    outline: none;
    padding: 12px 24px;
    border-radius: 4px;
    transition: background-color 0.1s ease 0s, box-shadow 0.1s ease 0s;
    border-width: 0px;
}
.WflZx {
    width: 100%;
    flex-flow: wrap;
}
.jmKqRE {
    width: 100%;
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
    max-width: 524px;
}
.cxEQKQ {
    margin-right: 30px;
}
.haTfuX {
    position: relative;
    width: 278px;
    height: 390px;
    background-color: rgb(255, 255, 255);
    background-size: cover;
    cursor: pointer;
    overflow: hidden;
    border-radius: 4px;
    transition: box-shadow 0.2s ease 0s;
}
.haTfuX:hover {
    box-shadow: rgba(186, 200, 227, 0.48) 0px 16px 36px -8px, rgba(186, 200, 227, 0.2) 0px 24px 60px -8px;
}
.kImuof {
    position: absolute;
    left: calc(50% - 18px);
    top: calc(50% - 18px);
    display: none;
    width: 36px;
    height: 36px;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    color: rgb(255, 255, 255);
    background-color: #7a85997a;
    border-radius: 50%;
}
.hCpORs {
    width: 100%;
    max-width: 212px;
}
.fBHvCq {
    display: flex;
    align-items: flex-start;
    padding-right: 26px;
    flex-flow: row nowrap;
}
.cLFOMf {
    position: relative;
    max-width: 100%;
}
.eRizKN {
    font-size: 22px;
    line-height: 28px;
    height: 32px;
    min-width: 1px;
    max-width: 100%;
    position: relative;
}
.kkRCtf {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
}
.gQXEKA {
    position: absolute;
    top: 2px;
    left: calc(100% + 2px);
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
}
.leOORe {
    position: relative;
}
.dsceFE {
    font-weight: 400;
    white-space: nowrap;
    left: 50%;
    transform: translate(-50%, 0px);
    position: absolute;
    z-index: 10;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.3px;
    color: rgb(255, 255, 255);
    width: auto;
    background-color: rgb(38, 43, 51);
    user-select: none;
    pointer-events: none;
    opacity: 0;
    bottom: calc(100% + 6px);
    padding: 5px 8px;
    border-radius: 3px;
    transition: opacity 0.2s ease 0s, transform 0.2s ease 0s;
}
.jxPiur {
    cursor: pointer;
    color: rgb(184, 190, 204);
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
}
.hsJJHO {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 2px;
    background-color: rgb(33, 150, 243);
    pointer-events: none;
    z-index: 1;
    opacity: 0;
    transform: scale(0.5, 0);
    transition: transform 0.1s ease 0s;
}
.jaiNr {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    margin-bottom: 16px;
}
.dXstwa:last-child {
    margin-bottom: 0px;
}
.dXstwa {
    font-size: 16px;
    line-height: 20px;
    color: rgb(152, 161, 179);
    margin-bottom: 8px;
}
.cNyPHU {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    margin-bottom: 12px;
    cursor: pointer;
    user-select: none;
    color: rgb(38, 43, 51);
    pointer-events: all;
}
.bWbDhC {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    color: rgb(33, 150, 243);
    margin-right: 5px;
}
.cNyPHU {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    margin-bottom: 12px;
    cursor: pointer;
    user-select: none;
    color: rgb(38, 43, 51);
    pointer-events: all;
}
.bWbDhC {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    color: rgb(33, 150, 243);
    margin-right: 5px;
}
.cNyPHU {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    margin-bottom: 12px;
    cursor: pointer;
    user-select: none;
    color: rgb(38, 43, 51);
    pointer-events: all;
}
.bWbDhC {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    color: rgb(33, 150, 243);
    margin-right: 5px;
}
.dHZVB {
    position: relative;
}
.cNyPHU {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    margin-bottom: 12px;
    cursor: pointer;
    user-select: none;
    color: rgb(38, 43, 51);
    pointer-events: all;
}
.bWbDhC {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    color: rgb(33, 150, 243);
    margin-right: 5px;
}
.cNyPHU:hover {
    color: #6ca7ff;
}
@media (max-width: 767px){
.jwoEpG {
    padding: 160px 20px 0px;
}}
@media (max-width: 767px){
.cbHCIC {
    margin-bottom: 13px;
}}
@media (max-width: 767px){
.iQGrHz {
    margin-bottom: 20px;
}}
@media (max-width: 767px){
.VvJwP {
    width: 100%;
    -webkit-box-pack: justify;
    justify-content: space-between;
}}
@media (max-width: 767px){
.ceBpjv {
    /* text-align: center;
    margin-right: 0px;
    flex: 1 1 0%; */
    width: 100%;
}}
@media (max-width: 767px){
.goxPqP {
    /* text-align: center;
    margin-right: 0px;
    flex: 1 1 0%; */
    width: 100%;
}}
@media (max-width: 767px){
.dqUEtJ {
    display: none;
}}
@media (max-width: 767px){
.cTABXS {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
}}
@media (max-width: 767px){
.jmKqRE {
    align-items: flex-start;
    margin-right: 0px;
    margin-bottom: 32px;
}}
@media (max-width: 767px){
.cxEQKQ {
    margin-right: 20px;
}}
@media (max-width: 767px){
.haTfuX {
    width: 108px;
    height: 151px;
}}
@media (max-width: 767px){
.kImuof {
    display: flex;
}}
/* .ceBpjv:before {
    content: "";
    position: absolute;
    width: 50%;
    height: 2px;
    background-color: #ee5150;
    transition: all 0.3s ease;
    left: 0;
    bottom: 0;
}
.goxPqP:after {
    content: "";
    position: absolute;
    width: 50%;
    height: 2px;
    background-color: #ee5150;
    transition: all 0.3s ease;
    right: 0;
    bottom: 0;
    display:none;
} */


/* LOADER */
.loader {
  --background: linear-gradient(135deg, #23C4F8, #275EFE);
  --shadow: rgba(39, 94, 254, 0.28);
  --text: #6C7486;
  --page: rgba(255, 255, 255, 0.36);
  --page-fold: rgba(255, 255, 255, 0.52);
  --duration: 3s;
  width: 200px;
  height: 140px;
  position: relative;
}
.loader:before, .loader:after {
  --r: -6deg;
  content: '';
  position: absolute;
  bottom: 8px;
  width: 120px;
  top: 80%;
  box-shadow: 0 16px 12px var(--shadow);
  -webkit-transform: rotate(var(--r));
          transform: rotate(var(--r));
}
.loader:before {
  left: 4px;
}
.loader:after {
  --r: 6deg;
  right: 4px;
}
.loader div {
  width: 100%;
  height: 100%;
  border-radius: 13px;
  position: relative;
  z-index: 1;
  -webkit-perspective: 600px;
          perspective: 600px;
  box-shadow: 0 4px 6px var(--shadow);
  background-image: var(--background);
}
.loader div ul {
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
}
.loader div ul li {
  --r: 180deg;
  --o: 0;
  --c: var(--page);
  position: absolute;
  top: 10px;
  left: 10px;
  -webkit-transform-origin: 100% 50%;
          transform-origin: 100% 50%;
  color: var(--c);
  opacity: var(--o);
  -webkit-transform: rotateY(var(--r));
          transform: rotateY(var(--r));
  -webkit-animation: var(--duration) ease infinite;
          animation: var(--duration) ease infinite;
}
.loader div ul li:nth-child(2) {
  --c: var(--page-fold);
  -webkit-animation-name: page-2;
          animation-name: page-2;
}
.loader div ul li:nth-child(3) {
  --c: var(--page-fold);
  -webkit-animation-name: page-3;
          animation-name: page-3;
}
.loader div ul li:nth-child(4) {
  --c: var(--page-fold);
  -webkit-animation-name: page-4;
          animation-name: page-4;
}
.loader div ul li:nth-child(5) {
  --c: var(--page-fold);
  -webkit-animation-name: page-5;
          animation-name: page-5;
}
.loader div ul li svg {
  width: 90px;
  height: 120px;
  display: block;
}
.loader div ul li:first-child {
  --r: 0deg;
  --o: 1;
}
.loader div ul li:last-child {
  --o: 1;
}
.loader span {
  display: block;
  left: 0;
  right: 0;
  top: 100%;
  margin-top: 20px;
  text-align: center;
  color: var(--text);
}

@-webkit-keyframes page-2 {
  0% {
    -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  35%,
        100% {
    opacity: 0;
  }
  50%,
        100% {
    -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
  }
}

@keyframes page-2 {
  0% {
    -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  35%,
        100% {
    opacity: 0;
  }
  50%,
        100% {
    -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
  }
}
@-webkit-keyframes page-3 {
  15% {
    -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
    opacity: 0;
  }
  35% {
    opacity: 1;
  }
  50%,
        100% {
    opacity: 0;
  }
  65%,
        100% {
    -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
  }
}
@keyframes page-3 {
  15% {
    -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
    opacity: 0;
  }
  35% {
    opacity: 1;
  }
  50%,
        100% {
    opacity: 0;
  }
  65%,
        100% {
    -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
  }
}
@-webkit-keyframes page-4 {
  30% {
    -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  65%,
        100% {
    opacity: 0;
  }
  80%,
        100% {
    -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
  }
}
@keyframes page-4 {
  30% {
    -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  65%,
        100% {
    opacity: 0;
  }
  80%,
        100% {
    -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
  }
}
@-webkit-keyframes page-5 {
  45% {
    -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
    opacity: 0;
  }
  65% {
    opacity: 1;
  }
  80%,
        100% {
    opacity: 0;
  }
  95%,
        100% {
    -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
  }
}
@keyframes page-5 {
  45% {
    -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
    opacity: 0;
  }
  65% {
    opacity: 1;
  }
  80%,
        100% {
    opacity: 0;
  }
  95%,
        100% {
    -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
  }
}
@media (max-width:767px) {
  .mcqueen_desktop{
    display:none!important;
  }
  .mcqueen_mobile{
    display:initial!important;
  }
  .navbar > .container, .navbar > .container-fluid{
    display: initial!important;
  }
}
.active_sidebar_dropdowns{
  background: #f3f5f9;
  color: #2a354f!important;
}
.active_create_type{
  background: #f3f5f9;
  color: #2a354f!important;
}
.scrollbar_choosedocument::-webkit-scrollbar {
    width: 0.5rem;
}
.scrollbar_choosedocument::-webkit-scrollbar-thumb {
    background: #b5babd;
    border-radius: 1rem;
}
@media(max-width:767px){
  .classdefranco{
    justify-content: center!important;
    flex-wrap: wrap!important;
  }
  .textoenmobilemodal{
    font-size: 15px!important;
    line-height: 26px!important;
    margin-bottom: 16px!important;
  }
  .modal-content-enmobile{
    margin-top: 40px!important;
    margin-bottom: 40px!important;
  }
}
.document_preview::-webkit-scrollbar {
  width: 0.5rem;
}
.document_preview::-webkit-scrollbar-thumb {
  background: #b5babd;
  border-radius: 1rem;
}
</style>

<script>
export default {
  props:['propsdata'],
  data(){
    return {
      toggle: false
    }
  },
  methods: {
    menu(){
      if(!this.toggle){
        this.toggle = true;
      }
      else{
        this.toggle = false;
      }
    }
},
mounted(){
}
    }
</script>



// WEBPACK FOOTER //
// src/Header.vue